// store 
import * as PractitionerStore from '../../../../redux/middleware/PractitionerMiddleware';
import * as PractitionerConsumptionStore from '../../../../redux/middleware/PractitionerConsumptionMiddleware';

// state
import { AppState } from '../../../../redux/reducers';

// models
import { Practitioner } from '../../../../models/Entities/Practitioners/Practitioner';
import { PractitionerConsumption } from '../../../../models/Entities/Practitioners/PractitionerConsumption';

//#region Props

interface IProps {
    PractitionerId: string;
    status: number;
}

interface ConnectedProps {
    isLoading: boolean;
    successLoading: boolean;
    failedLoading: boolean;
    error: string | null;
    Consumptions: PractitionerConsumption[];
    ConsumptionToSettle: PractitionerConsumption[];
    TotalByCurrency: {Total: number, Currency: string}[];
    practitioner: Practitioner | null;    
}

interface PractitionerDispatchProps {
    GetPractitionerById: typeof PractitionerStore.actionCreators.GetPractitionerById;
    GetPractitionerConsumptionsToSettle: typeof PractitionerConsumptionStore.ActionCreators.GetPractitionerConsumptionsToSettle;
    GetAllPractitionerContractAssociations: typeof PractitionerStore.actionCreators.GetAllPractitionerContractAssociations;
}

export type Props = IProps & ConnectedProps & PractitionerDispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => {
    const AuxPractitioner: Practitioner | null = state.Practitioners?.list?.find((practitioner: Practitioner) => practitioner.userId === ownProps.PractitionerId) || null;

    const AuxConsumptionsToSettle : PractitionerConsumption[] = AuxPractitioner?.consumptionToSettle || [];

    const AuxConsumptions: PractitionerConsumption[] = AuxPractitioner?.consumptions?.filter(consumption => consumption.status === ownProps.status) || [];

    const AuxConceptTotalByCurrency: {Total: number, Currency: string}[] = AuxConsumptionsToSettle.reduce((acc: {Total: number, Currency: string}[], consumption: PractitionerConsumption) => {
            const existing = acc.find(item => item.Currency === consumption.currencyCode);
            if (existing) {
                existing.Total += consumption.amount;
            } else {
                acc.push({ Total: consumption.amount, Currency: consumption.currencyCode });
            }
            return acc;
        }, []);

    return {
        isLoading: AuxPractitioner?.isLoadingConsumptionToSettle || false,
        successLoading: AuxPractitioner?.loadedConsumptionToSettleSuccessfully || undefined,
        failedLoading: AuxPractitioner?.failOnLoadConsumptionToSettle || false,
        error: AuxPractitioner?.errorOnLoadConsumptionToSettle || null,
        
        Consumptions: AuxConsumptions || [],
        ConsumptionToSettle: AuxConsumptions.filter(consumption => consumption.status === ownProps.status) || [],
        TotalByCurrency: AuxConceptTotalByCurrency,
        practitioner: AuxPractitioner
    }
};

export const mapDispatchToProps = {
    ...PractitionerStore.actionCreators,
    ...PractitionerConsumptionStore.ActionCreators,
};

export const GetStatusDescription = (status: number) => {
    switch (status) {
        case 0:
            return 'Pending settlement';
        case 1:
            return 'With pending balance';
        case 2:
            return 'Paid';
        case 3:
            return 'Settled';
        case 4:
            return 'Rejected';
        case 5:
            return 'Ignored';
        case 6:
            return 'To settle';
        default:
            return 'Unknown';
    }
}
